export default "__VITE_ASSET__Dcbz9a23__"